import React from 'react';
import { injectIntl } from 'react-intl';

import PreLoginCard from '../../components/preLoginCard/PreLoginCard';


export default injectIntl(
  ({ intl }) => (
    <div>
      <h1 className="ui inverted header">{intl.formatMessage({ id: 'login.signIn' })}</h1>
      <PreLoginCard
        title={intl.formatMessage({ id: 'login.enter' })}
        loginText={intl.formatMessage({ id: 'login.text.login' })}
        newText={intl.formatMessage({ id: 'login.text.newAccount' })}
        buttonLabel={intl.formatMessage({ id: 'login.action.linkedin' })}
        linkedinLink="http://api.futurecom.com.br/login-linkedin"
        formLink="/login/form"
        newLink="/login/new"
      />
    </div>
  )
);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/pages/login/index.js
 **/